/**
 * Class representing Module.(js-doc)
 */
export default class Module {
  /**
   * Create a Module.(js-doc)
   * @param {string} name - module name.
   * @param {object} element - element.
   */
  constructor(name, element) {
    this.name = name;
    this.master = element;
  }
  /**
   * Init module. (js-doc)
   */
  start() {}
}

